import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import HomePage from './components/HomePage'
import About from './components/About'
import ProductPage from './components/ProductPage'
import Solutions from './components/Solutions'
import Services from './components/Services'
import Gallery from './components/Gallery'
import Contact from './components/Contact'
import AdminLogin from './components/AdminLogin'
import ReportsSubmitted from './components/ReportsSubmitted'




const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "products/:category",
        element: <ProductPage />,
      },
      {
        path: "solutions",
        element: <Solutions />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "gallery",
        element: <Gallery />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "adminLogin",
        element: <AdminLogin />,
      },
      {
        path: "reportsSubmitted",
        element: <ReportsSubmitted />,
      },
    ],
  },
  // {
  //   path: "/about",
  //   element: <About />,
  // },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    {/* <App /> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
